module.exports = __webpack_public_path__ + "img/img_test_avatar.839d698e.jpg";